export type TBranding = {
  logo_url?: string;
  primary_color?: string;
  agent_name?: string;
  text_color?: 'light' | 'dark' | 'auto';
};

export type ResolvedBranding = {
  logoUrl?: string;
  logoSource?: BrandingLevel;
  primaryColor?: string;
  colorSource?: BrandingLevel;
  textColor?: 'light' | 'dark' | 'auto';
  textColorSource?: BrandingLevel;
};

export type BrandingLevel = 'default' | 'job' | 'template' | 'client';

export const defaultBrandingPrimaryColor = '#794dff';
export const defaultBrandingTextColor = 'auto';
export const defaultBrandingColorSource = 'default';
export const defaultBrandingLogoUrl = undefined;
export const defaultBrandingLogoSource = 'default';

export const defaultBranding: ResolvedBranding = {
  primaryColor: defaultBrandingPrimaryColor,
  logoUrl: defaultBrandingLogoUrl,
  colorSource: defaultBrandingColorSource,
  logoSource: defaultBrandingLogoSource,
};
